import { Dialog, DialogTitle, DialogContent, Typography, Button, DialogActions } from '@mui/material'
import { quoteLineType } from '../../types'

export function DeleteDialog({
  open,
  onClose,
  onConfirm,
  lineItems,
}: {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  lineItems?: quoteLineType[]
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle variant="h6">
        Delete {lineItems?.length ?? ''} Line Item{lineItems?.length && lineItems.length > 1 ? 's' : ''}
      </DialogTitle>
      <DialogContent className="action-bar-dialog-content">
        <Typography variant="body1">
          Are you sure you want to delete the selected line item{lineItems?.length && lineItems.length > 1 ? 's' : ''}?
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions className="action-bar-dialog-actions">
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm()
            onClose()
          }}
          variant="contained"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
